import { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  ChevronRight,
  CreditCard,
  IdCard,
  KeyRound,
  Users
} from 'lucide-react';

// Hero image - Boles UGOLF Aravell + Anyós Park amb muntanyes
const HERO_IMAGE = 'https://customer-assets.emergentagent.com/job_c71ccf0b-f871-4091-bddc-a51aa7862b88/artifacts/owgn3p42_bolas%20aravell%20anyos.png';

// NUTS Logo
const NUTS_ANYOS_LOGO = 'https://customer-assets.emergentagent.com/job_c71ccf0b-f871-4091-bddc-a51aa7862b88/artifacts/ilo445oe_NUTS%20especial%20ANYOS.png';

const AnyosParkPage = () => {
  return (
    <main className="min-h-screen bg-white" data-testid="anyos-park-page">
      {/* Hero Section */}
      <section className="relative overflow-hidden">
        <div className="w-full">
          <img 
            src={HERO_IMAGE} 
            alt="UGOLF Aravell & Anyós Park" 
            className="w-full h-auto"
          />
        </div>
      </section>

      {/* Two Columns Section */}
      <section className="py-16 bg-white">
        <div className="container-custom">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12">
            
            {/* Left Column - Golfers */}
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-[#F9F9F7] rounded-2xl p-8 md:p-10"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-[#1A4D2E] rounded-full flex items-center justify-center">
                  <CreditCard className="w-6 h-6 text-white" />
                </div>
                <h2 className="font-display text-xl md:text-2xl text-[#1A4D2E] font-bold">
                  Ja jugues a golf?
                </h2>
              </div>
              
              <p className="text-gray-700 mb-6 leading-relaxed">
                Si ets jugador de golf i soci d'Anyós Park El Club vine a UGOLF ARAVELL Andorra i gaudeix d'un preu especial.
              </p>
              
              <a 
                href="https://open.teeone.golf/es/aravell"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 bg-[#1A4D2E] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#153d24] transition-colors mb-6"
                data-testid="reserva-greenfee-btn"
              >
                RESERVA
                <ChevronRight className="w-5 h-5" />
              </a>
              
              <div className="space-y-4 mt-6 pt-6 border-t border-gray-200">
                <div className="flex items-start gap-3">
                  <KeyRound className="w-5 h-5 text-[#D4AF37] mt-1 flex-shrink-0" />
                  <p className="text-gray-600 text-sm">
                    Introdueix el codi que et facilita Anyós Park a la seva graella d'activitats.
                  </p>
                </div>
                
                <div className="flex items-start gap-3">
                  <IdCard className="w-5 h-5 text-[#D4AF37] mt-1 flex-shrink-0" />
                  <p className="text-gray-600 text-sm">
                    Paga el teu greenfee al arribar al camp, recorda presentar el teu document que t'acredita com a soci d'Anyós Park El Club junt al teu document d'identitat.
                  </p>
                </div>
              </div>
            </motion.div>

            {/* Right Column - Beginners */}
            <motion.div
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              className="bg-[#1A4D2E] rounded-2xl p-8 md:p-10 text-white"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center">
                  <Users className="w-6 h-6 text-white" />
                </div>
                <h2 className="font-display text-xl md:text-2xl font-bold">
                  Vols descobrir el golf?
                </h2>
              </div>
              
              <p className="text-white/90 mb-6 leading-relaxed">
                Si ets soci d'Anyós Park El Club tens la oportunitat de descobrir el golf a un preu especial i junt a altres socis.
              </p>
              
              <p className="text-white/90 mb-8 leading-relaxed">
                Comença per la sessió d'iniciació de <span className="font-bold text-[#D4AF37]">3 hores</span>.
              </p>
              
              <div className="flex justify-center mb-6">
                <img 
                  src={NUTS_ANYOS_LOGO}
                  alt="NUTS especial Anyós Park"
                  className="h-28 md:h-32 bg-white rounded-xl p-4"
                />
              </div>
              
              <Link 
                to="/iniciacio-anyos"
                className="w-full inline-flex items-center justify-center gap-2 bg-[#D4AF37] text-[#1A4D2E] px-6 py-4 rounded-lg font-bold hover:bg-[#b8952e] transition-colors text-lg"
                data-testid="iniciacio-btn"
              >
                Dona el primer cop!
                <ChevronRight className="w-5 h-5" />
              </Link>
            </motion.div>

          </div>
        </div>
      </section>
    </main>
  );
};

export default AnyosParkPage;
